// Components
import {
  TableChart,
  TableAgrupmentsChart,
} from 'pages/bdos/Reports/pages/TableEntryReport/components/ChartReport';
import { TablePayments } from 'pages/bdos/Reports/pages/ReceiptsReport/components/ReceiptsReportDatails';
import {
  PaymentNavigation,
  TransactionNavigation,
} from 'pages/bdos/Reports/pages/OnboardSalesReport/components/OnboardSalesReportDatails';
import {
  SellingPaymentNavigation,
  SellingTransactionNavigation,
} from 'pages/bdos/Reports/pages/CollectionReport/components/CollectionReportDatails';
import { TransactionNavigation as TransportVoucherCollectio } from 'pages/bdos/Reports/pages/TransportVoucherCollectionReport/components/TransportVoucherCollectionReportDatails';
import { DetailedCompanyAcquisitions } from 'pages/bdos/Reports/pages/CompanyAcquisitionsReport/components/CompanyAcquisitionsReportDatails';
import { DetailedImportationsReport } from 'pages/bdos/Reports/pages/ImportationsReport/components/ImportationsReportDatails';
import { TableEmtuReport } from 'pages/bdos/Reports/pages/EmtuReport/components/EmtuReportDatails';
import { TableLineDemandReport } from 'pages/bdos/Reports/pages/LineDemandReport/components/LineDemandReportDatails';
import { TableLineQuantityReport } from 'pages/bdos/Reports/pages/LineQuantityReport/components/LineQuantityReportDetails';
import { TableSegmentDemandReport } from 'pages/bdos/Reports/pages/SegmentDemandReport/components/SegmentDemandReportDatails';
import { TableSegmentQuantityReport } from 'pages/bdos/Reports/pages/SegmentQuantityReport/components/SegmentQuantityReportDetails';
import { TableDailyDemandReport } from 'pages/bdos/Reports/pages/DailyDemandReport/components/DailyDemandReportDatails';
import { TableDailyQuantityReport } from 'pages/bdos/Reports/pages/DailyQuantityReport/components/DailyQuantityReportDatails';
import { TableCarDemand } from 'pages/bdos/Reports/pages/CarDemandReport/components/CarDemandReportDatails';
import { TableCarQuantity } from 'pages/bdos/Reports/pages/CarQuantityReport/components/CarQuantityReportDetails';
import { TableTravel } from 'pages/bdos/Reports/pages/HalfTripDiary/components/HalfTripDiaryDatails';
import { TableOperatorCommission } from 'pages/bdos/Reports/pages/OperatorCommissionReport/components/OperatorCommissionReportDatails';
import { TableTravelByLineReport } from 'pages/bdos/Reports/pages/TravelByLine/components/TravelByLineDatails';
import { TablePaymentRequest } from 'pages/bdos/Reports/pages/PaymentRequest/components/PaymentRequestDatails';

// Actions
import * as ReportActions from 'store/ducks/reports/actions';
import * as EmployeesSalesActions from 'store/ducks/employeesSales/actions';
import * as SellingTerminalsActions from 'store/ducks/sellingTerminals/actions';
import * as CompaniesActions from 'store/ducks/companies/actions';
import * as FleetActions from 'store/ducks/fleet/actions';
import * as TripsActions from 'store/ducks/trips/actions';
import * as EmployeesActions from 'store/ducks/employees/actions';
import {
  listCompanyReportRequest,
  importaionsReportRequest,
} from 'store/ducks/company/actions';

const OPERATOR = {
  CONSORTIUM: 1,
};

const REPORTS_TYPES = {
  ENTRY_VALUE_SIMPLIFIED: 'entry_value_simplified',
  ENTRY_VALUE: 'entry_value',

  SUPERVISOR_PAYMENT: 'supervisor_payment', // old api: paymentReport

  EMPLOYEE_TRANSACTION: 'employee_transaction', // old type: transaction, old api: employeeReports
  EMPLOYEE_PAYMENT: 'employee_payment', // old type: payment, old api: employeeReports
  EMPLOYEE_RESUME: 'employee_resume', // old type: resume, old api: employeeReports

  SELLING_RESUME: 'selling_resume', // old type: resume, old api: sellingReports
  SELLING_TERMINAL_PAYMENT: 'selling_terminal_payment', // old type: terminalPayment, old api: sellingReports
  SELLING_TRANSACTION: 'selling_transaction', // old type: transaction, old api: sellingReports
  SELLING_TERMINAL_WALLET_BALANCE: 'selling_terminal_pre_paid_balance',

  CHARGE_GENERAL: 'charge_general', // old api: companyReport
  CHARGE_MONTH_REPORT: 'charge_month_report', // old type: month_report, old api: companyReport
  CHARGE_VAN_FILE: 'charge_van_file', // old type: month_report, old api: companyReport

  LINE_VALUE: 'line_value',
  LINE_QUANTITY: 'line_quantity',
  CAR_QUANTITY: 'car_quantity',
  ENTRY_SECCIONED: 'entry_seccioned', // old type: line_seccioned
  ENTRY_SECCIONED_QUANTITY: 'entry_seccioned_quantity', // old type: line_seccioned
  ENTRY_DAILY: 'entry_daily', // old type: daily_entry
  ENTRY_QUANTITY: 'entry_quantity',
  REPORT_ENTRY_BY_HOUR: 'entry_by_hour_range',
  REPORT_ENTRY_BY_HOUR_BY_PROFILE: 'entry_by_hour_range_by_profile',
  REPORT_ENTRIES_BY_COLLECTION: 'entry_by_collection',

  CAR_ENTRY: 'car_entry', // old type: entry, old api: carReports
  CAR_KM_BY_DAY: 'car_km_by_day',

  PASSENGERS_AND_VEHICLES: 'trip_passengers_vehicles',
  PASSENGERS_AND_VEHICLES_BY_TRIP: 'trip_passengers_vehicles_detail',
  TIMED_OUT_ENTRIES: 'timed_out_entries',
  PEDESTRIAN_ENTRY_BY_TERMINAL: 'pedestrian_entry_per_terminal',

  TRIP: 'trip', // old api: tripReport

  EMPLOYEE_ENTRY: 'employee_entry', // old type: entry, old api: employeeReports

  LINE_KM: 'line_km',

  ENTRY_ALL_BY_DAY: 'entry_all_by_day', // old type: all_by_day
  ENTRY_VALUE_EVOLUTION: 'entry_value_evolution', // old type: value_evolution
  ENTRY_HEATMAP: 'entry_heatmap', // old type: heatmap
  USER_VALUES: 'user_values', // old type: user_values

  STOP_IN_OUT: 'stop_in_out', // old type: in_out, old api: stopReports

  TRIP_CONTROL_DAILY_RESUME: 'trip_control_daily_resume', // old api: tripReport

  SELLING_POINT_DAILY_RESUME: 'selling_point_daily_resume', // old api: sellingReports

  SELLING_TERMINAL_DAILY_RESUME: 'selling_terminal_daily_resume', // old type: terminal_daily_resume, old api: sellingReports

  ENTRY_BY_USER: 'entry_by_user',

  EMPLOYEE_DAILY_RESUME: 'employee_daily_resume', // old type: daily_resume, old api: employeeReports
  EMPLOYEE_TRIP_RESUME: 'employee_trip_resume', // old type: resume, old api: employeeReports

  SELLING_TERMINAL_PAYMENT_REQUEST: 'selling_terminal_payment_request',

  SHIPMENT_BY_LINE_REPORT_TYPE: 'line_entries',

  TRANSPORTED_PASSENGERS: 'transported_passengers',
  KM_DRIVED: 'km_drived',
  ORDERS_BY_SCHOOL: 'orders_by_school',
  CREDIT_USAGE_BY_INSTITUTION: 'credit_usage_by_institution',
  PASSENGERS_BY_TIME_FRAME: 'passengers_by_time_frame',
  PASSENGERS_BY_TIME_FRAME_BY_PROFILE: 'passengers_by_time_frame_by_profile',
  REPORT_STUDENTS_DEVICE: 'students_device',

  REPORT_ENTRY_BY_MONTH: 'entry_by_month',
  REPORT_KM_BY_MONTH: 'km_by_month',

  REPORT_GATE_ENTRY: 'gate_entry',

  REPORT_INCOMING_CONSOLIDATION: 'incoming_by_km_value',
  TICKET_AVERAGE_REPORT: 'ticket_average_report', // temporary
  TRIP_COLLECTION: 'trip_collection',

  EMV: 'entry_emv',
  EMV_DECLINED_BY_REASON: 'declined_by_reason',
  EMV_APPROVED_BY_BRAND: 'approved_by_brand',
  EMV_APPROVED_BY_DEBT_RECOVERY: 'approved_by_debt_recovery',
  EMV_APPROVED_BY_ATTEMPTS: 'approved_by_attempts',
  EMV_APPROVED_FIRST_TAP_BY_BRAND: 'approved_first_tap_by_brand',

  TRIPCONTROL_DETAIL_RESUME: 'trip_control_detail_resume',
  REPORT_CREDIT_PER_SCHOOL: 'entry_by_school',
  USAGE_STATISTICS: 'entry_percentage_per_profile',
  ENTRY_PER_AGE_GROUPE: 'entry_per_age_group',
  SELLING_POINT_REAL_TIME: 'selling_point_real_time',
  REPORT_BOARDING_HISTORY: 'boarding_history',
  TRIP_CONTROL_KM_DAILY_RESUME: 'trip_control_km_daily_resume',
  BPE: 'bpe_and_transported_passengers',
  BPE_TAX_VERIFICATION: 'bpe_tax_verification',
  FREE_ENTRY_REPORT: 'free_entry_report',
  BPE_BY_DOCUMENT: 'bpe_by_document',

  EMPLOYEE_TRIP_SAP_RESUME: 'employee_trip_sap_resume',
};
const REPORTS_TYPES_LABELS = [
  { key: 'bpe_and_transported_passengers', value: 'Bilhetagem eletrônica' },
  { key: 'bpe_tax_verification', value: 'BPe apuração do ICMS' },
];

const TRIP_COLLECTION_TYPE: { [key: number]: string } = {
  0: 'entry',
  1: 'trip',
  2: 'total',
  3: 'total',
};
const TRIP_COLLECTION_GROUP = {
  PLACE: 'place',
  DBD: 'dbd',
};

export default {
  TABLE_HEADER: new Map([
    ['fareValue', 'Tarifa'],
    ['quantity', 'Quantidade'],
    ['totalValue', 'Valor'],
  ]),

  FREQUENCY_TYPE: [
    { KEY: 0, VALUE: 'Diária' },
    { KEY: 1, VALUE: 'Semanal' },
    { KEY: 2, VALUE: 'Mensal' },
    { KEY: 3, VALUE: 'Anual' },
  ],
  FREQUENCY_TYPE_SELECT: [
    { KEY: 0, VALUE: 'Dias' },
    { KEY: 1, VALUE: 'Semanas' },
    { KEY: 2, VALUE: 'Meses' },
    { KEY: 3, VALUE: 'Anos' },
  ],
  FREQUENCY_WEEK_DAY: [
    { KEY: 'SUNDAY', VALUE: 'Domingo' },
    { KEY: 'MONDAY', VALUE: 'Segunda' },
    { KEY: 'TUESDAY', VALUE: 'Terça' },
    { KEY: 'WEDNESDAY', VALUE: 'Quarta' },
    { KEY: 'THURSDAY', VALUE: 'Quinta' },
    { KEY: 'FRIDAY', VALUE: 'Sexta' },
    { KEY: 'SATURDAY', VALUE: 'Sabado' },
  ],

  FILTERS_GROUPING: [
    { KEY: 'type', VALUE: 'Tipo' },
    { KEY: 'transportOperatorId', VALUE: 'Operador' },
    { KEY: 'lineId', VALUE: 'Linha' },
    { KEY: 'profileId', VALUE: 'Perfil' },
    { KEY: 'startDate', VALUE: 'Data de Início' },
    { KEY: 'endDate', VALUE: 'Data de Fim' },
    { KEY: 'paymentType', VALUE: 'Tipo de Pagamento' },
    { KEY: 'dbdId', VALUE: 'DBD' },
    { KEY: 'facial', VALUE: 'Reconhecimento Facial' },
    { KEY: 'userId', VALUE: 'Usuário' },
    { KEY: 'carId', VALUE: 'Carro' },
    { KEY: 'seccioned', VALUE: 'Seccionamento' },
    { KEY: 'usageType', VALUE: 'Tipo de Embarque' },
    { KEY: 'qrcodeType', VALUE: 'Tipo do QRCode' },
    { KEY: 'employeeId', VALUE: 'Motorista' },
    { KEY: 'quantity', VALUE: 'Quantidade' },
    { KEY: 'tokenStatus', VALUE: 'Status do QRCode' },
    { KEY: 'timestamp', VALUE: 'Data' },
    { KEY: 'status', VALUE: 'Status' },
    { KEY: 'dateType', VALUE: 'Tipo de Data' },
    { KEY: 'filename', VALUE: 'Nome do Arquivo' },
    { KEY: 'employeeIds', VALUE: 'Motorista' },
    { KEY: 'tripId', VALUE: 'Viagem' },
    { KEY: 'transactionType', VALUE: 'Tipo de Venda' },
    { KEY: 'chargeType', VALUE: 'Tipo de Recarga' },
    { KEY: 'sellingTerminalId', VALUE: 'Rede de Venda' },
    { KEY: 'sellingPointId', VALUE: 'Ponto de Venda' },
    { KEY: 'stopId', VALUE: 'Parada' },
    { KEY: 'supervisorId', VALUE: 'Supervisor' },
    { KEY: 'start', VALUE: 'Data de Início' },
    { KEY: 'end', VALUE: 'Data de Fim' },
    { KEY: 'employeeIds', VALUE: 'Motorista' },
    { KEY: 'lineIds', VALUE: 'Linhas' },
    { KEY: 'carIds', VALUE: 'Carros' },
    { KEY: 'csv', VALUE: 'CSV' },
    { KEY: 'positiveOnly', VALUE: 'Apenas Positivos' },
    { KEY: 'ignoreFreeProfile', VALUE: 'Apenas Perfis Pagos' },
    { KEY: '_group', VALUE: 'Agrupamentos' },
    { KEY: 'createdAt', VALUE: 'Data de criação' },
    { KEY: 'updatedAt', VALUE: 'Data de atualização' },
    { KEY: 'reportType', VALUE: 'Tipo de relatório' },
    { KEY: 'usedDate', VALUE: 'Data' },
    { KEY: 'amount', VALUE: 'Valor' },
    { KEY: 'testOnly', VALUE: 'Teste' },
  ],

  REPORT_TYPE_COMPONENT: [
    // Relatórios de Embarque • Entradas
    {
      KEY: REPORTS_TYPES.ENTRY_VALUE_SIMPLIFIED,
      ACTION: ReportActions.getChartEntryReportSimplifiedRequest,
      VALUE: TableChart,
      INCLUDES: '',
    },
    {
      KEY: REPORTS_TYPES.ENTRY_VALUE,
      ACTION: ReportActions.entryReportGroupedRequest,
      VALUE: TableAgrupmentsChart,
      INCLUDES: '',
    },

    // Relatórios de Arrecadação • Recebimentos
    {
      KEY: REPORTS_TYPES.SUPERVISOR_PAYMENT,
      ACTION: ReportActions.paymentReportRequest,
      VALUE: TablePayments,
      INCLUDES: '',
    },

    // Relatórios de Arrecadação • Vendas à Bordo
    {
      KEY: REPORTS_TYPES.EMPLOYEE_PAYMENT,
      ACTION: EmployeesSalesActions.listPaymentsRequest,
      VALUE: PaymentNavigation,
      INCLUDES: 'supervisor',
    },
    {
      KEY: REPORTS_TYPES.EMPLOYEE_TRANSACTION,
      ACTION: EmployeesSalesActions.listTransactionsRequest,
      VALUE: TransactionNavigation,
      INCLUDES: 'token',
    },

    // Relatórios de Arrecadação • Rede de Vendas
    {
      KEY: REPORTS_TYPES.SELLING_TERMINAL_PAYMENT,
      ACTION: SellingTerminalsActions.listPaymentsRequest,
      VALUE: SellingPaymentNavigation,
      INCLUDES: 'terminal',
    },
    {
      KEY: REPORTS_TYPES.SELLING_TRANSACTION,
      ACTION: SellingTerminalsActions.listTransactionsRequest,
      VALUE: SellingTransactionNavigation,
      INCLUDES: '',
    },

    // Relatório de Arrecadação • Vale Transporte
    {
      KEY: REPORTS_TYPES.CHARGE_GENERAL,
      ACTION: CompaniesActions.reportCompanyRequest,
      VALUE: TransportVoucherCollectio,
      INCLUDES: 'payment,history,order',
    },

    // Relatórios de Empresas • Compras
    {
      KEY: REPORTS_TYPES.CHARGE_MONTH_REPORT,
      ACTION: listCompanyReportRequest,
      VALUE: DetailedCompanyAcquisitions,
      INCLUDES: '',
    },

    // Relatórios de Empresas • Importações
    {
      KEY: REPORTS_TYPES.CHARGE_VAN_FILE,
      ACTION: importaionsReportRequest,
      VALUE: DetailedImportationsReport,
      INCLUDES: '',
    },

    // Relatórios de Operação • Saldo
    {
      KEY: REPORTS_TYPES.USER_VALUES,
      ACTION: ReportActions.emtuReportRequest,
      VALUE: TableEmtuReport,
      INCLUDES: '',
    },

    // Relatórios de Operação • Demanda por Linha
    {
      KEY: REPORTS_TYPES.LINE_VALUE,
      ACTION: ReportActions.lineDemandReportRequest,
      VALUE: TableLineDemandReport,
      INCLUDES: '',
    },

    // Relatórios de Operação • Quantidade por Linha
    {
      KEY: REPORTS_TYPES.LINE_QUANTITY,
      ACTION: ReportActions.lineQuantityReportRequest,
      VALUE: TableLineQuantityReport,
      INCLUDES: '',
    },

    // Relatórios de Operação • Demanda por Trecho
    {
      KEY: REPORTS_TYPES.ENTRY_SECCIONED,
      ACTION: ReportActions.lineDemandReportRequest,
      VALUE: TableSegmentDemandReport,
      INCLUDES: '',
    },

    // Relatórios de Operação • Quantidade por Trecho
    {
      KEY: REPORTS_TYPES.ENTRY_SECCIONED_QUANTITY,
      ACTION: ReportActions.lineQuantityReportRequest,
      VALUE: TableSegmentQuantityReport,
      INCLUDES: '',
    },

    // Relatórios de Operação • Demanda por Dia
    {
      KEY: REPORTS_TYPES.ENTRY_DAILY,
      ACTION: ReportActions.dailyDemandReportRequest,
      VALUE: TableDailyDemandReport,
      INCLUDES: '',
    },

    // Relatórios de Operação • Quantidade por Dia
    {
      KEY: REPORTS_TYPES.ENTRY_QUANTITY,
      ACTION: ReportActions.dailyQuantityReportRequest,
      VALUE: TableDailyQuantityReport,
      INCLUDES: '',
    },

    // Relatórios de Operação • Demanda por Carro
    {
      KEY: REPORTS_TYPES.CAR_ENTRY,
      ACTION: FleetActions.listCarsReportRequest,
      VALUE: TableCarDemand,
      INCLUDES: '',
    },

    // Relatórios de Operação • Quantidade por Carro
    {
      KEY: REPORTS_TYPES.CAR_QUANTITY,
      ACTION: FleetActions.listCarsReportQuantityRequest,
      VALUE: TableCarQuantity,
      INCLUDES: '',
    },

    // Relatórios de Operação • Meia Viagem
    {
      KEY: REPORTS_TYPES.TRIP,
      ACTION: TripsActions.tripReportRequest,
      VALUE: TableTravel,
      INCLUDES: '',
    },
    // Relatórios de Operação • Comissão de Operadores
    {
      KEY: REPORTS_TYPES.EMPLOYEE_ENTRY,
      ACTION: EmployeesActions.getEmployeesReportRequest,
      VALUE: TableOperatorCommission,
      INCLUDES: 'token',
    },

    // Relatórios de Operação • Viagens por Linha
    {
      KEY: REPORTS_TYPES.LINE_KM,
      ACTION: ReportActions.travelByLineReportRequest,
      VALUE: TableTravelByLineReport,
      INCLUDES: '',
    },
    // Relatórios de Arrecadação • Requisição Pagamento
    {
      KEY: REPORTS_TYPES.SELLING_TERMINAL_PAYMENT_REQUEST,
      ACTION: ReportActions.paymentRequestListRequest,
      VALUE: TablePaymentRequest,
      INCLUDES: '',
    },
  ],

  REPORT_NAME: [
    {
      KEY: 'entry_value_simplified',
      NAME: 'Detalhado',
    },
    {
      KEY: 'entry_value',
      NAME: 'Agrupado',
    },
    {
      KEY: 'employee_payment',
      NAME: 'Repasses',
    },
    {
      KEY: 'employee_transaction',
      NAME: 'Transações',
    },
    {
      KEY: 'selling_terminal_payment',
      NAME: 'Repasses Rede de Vendas',
    },
    {
      KEY: 'selling_transaction',
      NAME: 'Transações Rede de Vendas',
    },
  ],
};

const TRIP_STATUS = [
  {
    KEY: 0,
    VALUE: 'Aberto',
  },
  {
    KEY: 1,
    VALUE: 'Fechado',
  },
];
export {
  REPORTS_TYPES,
  REPORTS_TYPES_LABELS,
  TRIP_COLLECTION_TYPE,
  TRIP_COLLECTION_GROUP,
  TRIP_STATUS,
  OPERATOR,
};
